import React, { useEffect, useState } from 'react';
import Menu from '../menu/Menu';
import './header.css';
import { Link } from 'react-router-dom';

const Header = (props) => {
  
  return(
    <header id='header' className=''>
      <Link to={'/Home'}>
        <div id="logo" className="header_brand logo logoS">
          <svg width="100%" height="100%" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M19.2534 13.1221L22.0554 10.3201H27.6279L30.4299 13.1221L29.1076 15.5463L26.6834 13.1221H19.2534Z" fill="#0577C5"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M19.2532 13.1221L16.4827 15.8926L13.6807 13.1221H19.2532Z" fill="#0577C5"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M20.1662 23.3856L19.2532 24.2671C19.2532 27.8561 19.3792 30.5007 19.9144 32.3582L9.05271 21.4966H3.44873L6.25072 18.6946H19.2532L16.4827 21.4966L19.2532 22.504L20.1662 23.3856Z" fill="#6EAFDC"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.25098 18.6946L11.8235 13.1221H13.681L16.483 15.8926L19.2535 13.1221H26.6835L28.6669 14.9481L22.0555 21.4966L20.1665 23.3855L19.2535 22.504L16.483 21.4966L19.2535 18.6946H6.25098Z" fill="#3495D7"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M19.2861 24.3109L16.4932 21.518H22.079L30.4578 13.1392C36.0437 14.7764 36.6216 19.3029 36.0437 24.3109H41.5333L38.7403 27.1038H38.8366C38.8366 27.1038 38.8366 32.4008 35.5622 35.0011L34.1175 33.5565H28.5317L19.2861 24.3109ZM27.6649 21.518L30.4578 24.3109L33.2508 21.518H27.6649Z" fill="#334460"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M30.458 24.3108L27.665 21.5178H33.2509L30.458 24.3108Z" fill="#6EAFDC"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M35.5622 35.001C34.5991 35.8678 33.2508 36.3493 31.4209 36.3493H25.8351C22.4643 36.3493 20.7308 35.2899 19.9603 32.4007C19.3824 30.4745 19.2861 27.8742 19.2861 24.3108L28.5317 33.5564H34.1176L35.5622 35.001Z" fill="#415B85"/>
          </svg>
        </div></Link>
        <Menu scroll={props.scroll} />
    </header>
)
}

export default (Header);
